module.exports = __webpack_public_path__ + "img/71_french.2dc975c5.jpg";